export default __webpack_public_path__ + "static/media/Switch-2.e760486f.jpg";